import { z } from 'zod';
export const FINANCIAL_STATUSES = [
    'PENDING',
    'AUTHORIZED',
    'PAID',
    'PARTIALLY_REFUNDED',
    'REFUNDED',
    'VOIDED',
];
export const FULFILLMENT_STATUSES = ['UNFULFILLED', 'PARTIAL', 'FULFILLED', 'RESTOCKED'];
export const listOrdersQuerySchema = z.object({
    search: z.string().max(255).optional(),
    financialStatus: z.enum(FINANCIAL_STATUSES).optional(),
    fulfillmentStatus: z.enum(FULFILLMENT_STATUSES).optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
//# sourceMappingURL=order.js.map